import { t } from "i18next";
import React, { useMemo } from "react";

import { ISortingGrade } from "../../utils/data-types";
import { monthString } from "../../utils/functions";
import { Text } from "../text/Text";
import "./SortingGrade.scss";
import { SortingGradePieChart } from "./recharts/SortingGradePieChart";

interface SortingGradeProps {
  dataYear1: ISortingGrade[] | undefined;
  dataYear2: ISortingGrade[] | undefined;
  customerId: number | undefined;
  year1: number;
  year2: number | undefined;
  selectedMonth: number;
  compareViewActive: boolean;
  isMonth: boolean;
}

export const SortingGrade = ({
  dataYear1,
  dataYear2,
  year1,
  year2,
  selectedMonth,
  compareViewActive,
  isMonth,
}: SortingGradeProps) => {
  const sortingGradeDesc = useMemo(() => {
    return t("pages.customersInfo.sortingGradeDesc");
  }, []);

  return (
    <div className="sorting-grade">
      <div className="sorting-grade__header">
        <Text
          text={t("pages.customersInfo.sortingGrade")}
          size="xs"
          color="dark"
          fontWeight={600}
        />
      </div>
      <div className="sorting-grade__content">
        <div className="table-header">
          <Text text={sortingGradeDesc} size="xxs" />
          <div>
            {isMonth && (
              <>
                <Text
                  className="green-month"
                  text={monthString(selectedMonth)}
                  size="xxs"
                  fontWeight={600}
                />
                <Text text="i" size="xxs" />
              </>
            )}
            <Text
              className="green-year"
              text={year1.toString()}
              size="xxs"
              fontWeight={600}
            />
            {compareViewActive && (
              <>
                <Text text={"og"} size="xxs" />
                <Text
                  className="green-year"
                  text={year2?.toString() ?? ""}
                  size="xxs"
                  fontWeight={600}
                />
              </>
            )}
          </div>
        </div>
        <div className="sorting-grade__content__chart">
          <div className="sorting-grade__content__chart__item">
            <div className="sorting-grade__content__chart__item__chart">
              <SortingGradePieChart data={dataYear1} isFirstChart />
              {compareViewActive && <SortingGradePieChart data={dataYear2} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
